// extracted by mini-css-extract-plugin
module.exports = {"catalog":"Catalog_catalog__2k3t_"};